import React from 'react';
interface Props {
  fillColor?: string;
}
function ChemoTherapyIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none">
      <g clipPath="url(#clip0_887_2726)">
        <path
          d="M1.5819 1.5H10.3819V2.5H1.5819V1.5ZM1.09301 0C0.552179 0 0.115234 0.446875 0.115234 1V3C0.115234 3.55312 0.552179 4 1.09301 4H10.8708C11.4116 4 11.8486 3.55312 11.8486 3V1C11.8486 0.446875 11.4116 0 10.8708 0H1.09301ZM1.09301 5V14C1.09301 15.1031 1.96996 16 3.04857 16H8.91523C9.99385 16 10.8708 15.1031 10.8708 14V5H9.40412V14C9.40412 14.275 9.18412 14.5 8.91523 14.5H3.04857C2.77968 14.5 2.55968 14.275 2.55968 14V5H1.09301ZM5.16607 7.5V8.66562H4.02635C3.75746 8.66562 3.53746 8.89062 3.53746 9.16562V9.83125C3.53746 10.1062 3.75746 10.3313 4.02635 10.3313H5.16607V11.4969C5.16607 11.7719 5.38607 11.9969 5.65496 11.9969H6.30579C6.57468 11.9969 6.79468 11.7719 6.79468 11.4969V10.3313H7.9344C8.20329 10.3313 8.42329 10.1062 8.42329 9.83125V9.16562C8.42329 8.89062 8.20329 8.66562 7.9344 8.66562H6.79468V7.5C6.79468 7.225 6.57468 7 6.30579 7H5.65496C5.38607 7 5.16607 7.225 5.16607 7.5Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_887_2726">
          <rect
            width="11.7333"
            height="16"
            fill="white"
            transform="translate(0.115234)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ChemoTherapyIcon;
